import React, { useEffect, useState } from 'react';
import axios from 'axios';
// SearchPanel, FilterRow, Scrolling, Paging 등을 추가로 import 합니다.
import DataGrid, { 
  Column, 
  FilterRow, 
  Selection, 
  SearchPanel, 
  Scrolling, 
  Paging,
  Button as GridButton 
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import API_URL from '../config';

export default function UserMenuAuthManager() {
  const [users, setUsers] = useState([]);
  const [menus, setMenus] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [assignedMenus, setAssignedMenus] = useState([]);
  const [selectedMenus, setSelectedMenus] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/oracle/users`);
      setUsers(res.data);
    } catch (err) {
      alert('사용자 목록 조회 실패');
    }
  };

  const fetchMenus = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/oracle/menu`);
      setMenus(res.data);
    } catch (err) {
      alert('메뉴 목록 조회 실패');
    }
  };

  const fetchAssignedMenus = async (userId) => {
    if (!userId) return;
    try {
      const res = await axios.get(`${API_URL}/api/oracle/usermenu/${userId}`);
      setAssignedMenus(res.data.map(m => m.MENU_ID));
      setSelectedMenus([]);
    } catch (err) {
      alert('권한 메뉴 조회 실패');
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchMenus();
  }, []);

  useEffect(() => {
    if (selectedUser) {
      fetchAssignedMenus(selectedUser.USER_ID);
    } else {
      setAssignedMenus([]);
      setSelectedMenus([]);
    }
  }, [selectedUser]);

  const onUserSelectionChanged = (e) => {
    const selectedRows = e.selectedRowsData;
    setSelectedUser(selectedRows.length > 0 ? selectedRows[0] : null);
  };

  const onMenuSelectionChanged = (e) => {
    setSelectedMenus(e.selectedRowKeys);
  };

  const onAddMenus = () => {
    const newAssigned = Array.from(new Set([...assignedMenus, ...selectedMenus]));
    setAssignedMenus(newAssigned);
    setSelectedMenus([]);
  };

  const onRemoveAssignedMenu = (menuId) => {
    setAssignedMenus(prev => prev.filter(id => id !== menuId));
  };

  const onSave = async () => {
    if (!selectedUser) {
      alert('사용자를 선택하세요.');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/oracle/usermenu/${selectedUser.USER_ID}`, {
        MENU_IDS: assignedMenus
      });
      alert('권한이 저장되었습니다.');
      fetchAssignedMenus(selectedUser.USER_ID);
    } catch (err) {
      alert('권한 저장 실패');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content lot-summary-page" style={{ padding: '20px' }}>
      {/* 로딩 오버레이 (App.css 스타일 참고) */}
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <div className="loading-text">권한 저장 중...</div>
        </div>
      )}

      <div style={{ display: 'flex', gap: 20 }}>
        {/* 1. 사용자 리스트 */}
        <div style={{ flex: 1 }}>
          <h3 className="section-bar">사용자 목록</h3>
          <DataGrid
            dataSource={users}
            keyExpr="USER_ID"
            height={600}
            showBorders={true}
            columnAutoWidth={true}
            onSelectionChanged={onUserSelectionChanged}
            rowAlternationEnabled={true}
          >
            <SearchPanel visible={true} width={240} placeholder="사용자 검색..." />
            <FilterRow visible={true} />
            <Selection mode="single" />
            <Scrolling mode="virtual" />
            <Paging enabled={false} />
            
            <Column dataField="USER_ID" caption="사용자ID" />
            <Column dataField="USER_NAME" caption="사용자명" />
            <Column dataField="EMAIL" caption="이메일" />
          </DataGrid>
        </div>

        {/* 2. 메뉴 목록 (할당 가능) */}
        <div style={{ flex: 1 }}>
          <h3 className="section-bar">할당 가능 메뉴</h3>
          <DataGrid
            dataSource={menus.filter(m => !assignedMenus.includes(m.MENU_ID))}
            keyExpr="MENU_ID"
            height={600}
            showBorders={true}
            columnAutoWidth={true}
            selectedRowKeys={selectedMenus}
            onSelectionChanged={onMenuSelectionChanged}
            rowAlternationEnabled={true}
          >
            <SearchPanel visible={true} width={240} placeholder="메뉴 검색..." />
            <FilterRow visible={true} />
            <Selection mode="multiple" showCheckBoxesMode="always" />
            <Scrolling mode="virtual" />
            <Paging enabled={false} />

            <Column dataField="MENU_NAME" caption="메뉴명" />
            <Column dataField="MENU_URL" caption="URL" />
          </DataGrid>
          
          <div style={{ marginTop: 15, display: 'flex', justifyContent: 'space-between' }}>
            <Button
              text="➡️ 선택 메뉴 추가"
              type="default"
              stylingMode="outlined"
              onClick={onAddMenus}
              disabled={selectedMenus.length === 0}
            />
            <Button
              text="💾 권한 저장"
              type="success"
              stylingMode="contained"
              onClick={onSave}
              disabled={loading || !selectedUser}
            />
          </div>
        </div>

        {/* 3. 할당된 메뉴 */}
        <div style={{ flex: 1 }}>
          <h3 className="section-bar">할당된 권한 메뉴</h3>
          <DataGrid
            dataSource={menus.filter(m => assignedMenus.includes(m.MENU_ID))}
            keyExpr="MENU_ID"
            height={600}
            showBorders={true}
            columnAutoWidth={true}
            rowAlternationEnabled={true}
          >
            <SearchPanel visible={true} width={240} placeholder="할당된 메뉴 검색..." />
            <FilterRow visible={true} />
            <Scrolling mode="virtual" />
            <Paging enabled={false} />

            <Column dataField="MENU_NAME" caption="메뉴명" />
            <Column dataField="MENU_URL" caption="URL" />
            <Column type="buttons" width={60} caption="제거">
              <GridButton
                icon="trash"
                hint="삭제"
                onClick={(e) => {
                  onRemoveAssignedMenu(e.row.data.MENU_ID);
                }}
              />
            </Column>
          </DataGrid>
        </div>
      </div>
    </div>
  );
}